import React, { useEffect, useReducer, useRef } from "react";

function reducer(state, action) {
  switch (action.type) {
    case "collapse":
      return {
        collapse: !state.collapse,
      };
    case "show":
      return {
        collapse: true,
      };
  }
}

export function Accordion({
  index,
  isActive,
  toggleAccordion,
  question = "",
  count = "",
  show = false,
  answer,
}) {
  const accordionBodyRef = useRef(null);
  const [{ collapse }, dispatch] = useReducer(reducer, {
    collapse: show,
  });

  const randomId = useRef(
    window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36)
  );

  useEffect(() => {
    if (show) dispatch({ type: "show" });
  }, [show]);

  return (
    <div
      className={`accordion-item  benefitcard relative flex flex-col h-full items-start bg-white hoverCardTop duration-300 overflow-hidden !px-[32px] py-6 lg:px-[20px] md:py-[37px] md:!pl-10 !pr-0 ${
        isActive && "gap-3"
      }`}
    >
      <div className="relative w-full">
        <h3
          className={`accordion-header !flex !items-center !justify-center !pr-[65px] md:!pr-28 ${
            isActive ? "" : "collapsed"
          }  font-sans font-bold uppercase text-[20px] leading-[100%] tracking-[-0.05em]`}
          id={`heading-${randomId.current}`}
          aria-expanded={isActive}
          aria-controls={`collapse-${randomId.current}`}
          onClick={() => toggleAccordion(index)}
        >
          <button
            className="!text-sm/5 lg:!text-[24px]/6 text-gunMetal  text-left flex gap-4 md:gap-6 !rounded-none !p-0 w-full"
            type="button"
          >
            <span className="pt-[2px] whitespace-nowrap md:inline">
              {count}
            </span>
            {question}
          </button>
        </h3>
        <div
          onClick={() => toggleAccordion(index)}
          className={`absolute right-3 lg:right-8 top-0 lg:-top-1.5 text-gunMetal size-5 lg:size-10 flex items-center justify-center cursor-pointer p-1 ${
            isActive ? "rotate-180" : "bg-accordientGD "
          }`}
        >
          {!isActive ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="12"
              viewBox="0 0 20 12"
              fill="none"
            >
              <path
                d="M19 1L10.7433 10.1741C10.3461 10.6155 9.65395 10.6155 9.25671 10.1741L1 1"
                stroke="url(#paint0_linear_3112_820)"
                strokeWidth="2.5"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3112_820"
                  x1="-25.283"
                  y1="160.147"
                  x2="29.2391"
                  y2="160.098"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#2EFF4A" />
                  <stop offset="0.891399" stopColor="#6688D1" />
                </linearGradient>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="12"
              viewBox="0 0 20 12"
              fill="none"
            >
              <path
                d="M19 1L10.7433 10.1741C10.3461 10.6155 9.65395 10.6155 9.25671 10.1741L1 1"
                stroke="#282B35"
                strokeWidth="2.5"
              />
            </svg>
          )}
        </div>
      </div>
      <div
        id={`collapse-${randomId.current}`}
        aria-labelledby={`heading-${randomId.current}`}
        className="accordion-collapse"
        style={
          isActive
            ? {
                height: accordionBodyRef.current?.clientHeight,
                transition: "height 0.2s ease",
                overflow: "hidden",
              }
            : {
                height: 0,
                transition: "height 0.2s ease",
                overflow: "hidden",
              }
        }
      >
        <div
          className="accordion-body text-left font-serif font-medium !pb-0 !px-8 md:!pl-[47px] md:!pr-[70px] text-sm text-sm/6  -tracking-[0.8px] text-gunMetal  opacity-[0.84]"
          ref={accordionBodyRef}
        >
          {typeof answer === "string" ? (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          ) : (
            answer
          )}
        </div>
      </div>
    </div>
  );
}
